import React from 'react';
import { Alert, Spin } from 'antd';

export function OiPageFrame({
  subtitle,
  loading,
  error,
  errorMessage,
  children,
}: {
  subtitle?: string;
  loading?: boolean;
  error?: boolean;
  errorMessage?: string;
  children: React.ReactNode;
}) {
  if (loading) {
    return <Spin style={{ display: 'block', margin: '48px auto' }} />;
  }
  if (error) {
    return <Alert type="error" message={errorMessage ?? 'Data unavailable'} showIcon />;
  }
  return (
    <div>
      {subtitle ? <p className="oi-subtitle">{subtitle}</p> : null}
      {children}
    </div>
  );
}
